import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivationStart } from '@angular/router';




@Injectable({
  providedIn: 'root'
})
export class RouteChangeNotifierService {

  constructor() { }

  private route : EventEmitter<string> = new EventEmitter(); 
  currentRoute: Observable<string> = this.route.asObservable();


  setRoute ( newRoute ) {
    
    this.route.next( newRoute );
  }

  getRoute():Observable<string> {
    return this.route.asObservable();
  }
  


}
